import buttoncss from "./../../css/button.module.css"
import Modal from "./../../elements/Modal";
import {Button} from "./../../elements/Button";
import Dropdown from "./../../elements/Dropdown";
import InputGroup from "./../../elements/InputGroup";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

const FilterDataModal = ({
  companies,
  handleClose,
  setFilterModal
}) => {

  return (
    <Modal
      title="Filters"
      headerActions={
        <lable className="primaryLable clickable">Reset Filters</lable>
      }
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              handleClose();
              setFilterModal(false);
            }}
            label="Cancel"
          />
          <Button btnColor={buttoncss.primary} label="Filter" />
        </>
      }
      onClose={() => console.log("Modal Closed")}
    >
      <Dropdown
        label="Company"
        options={companies}
        onSelect={(value) => console.log("Selected:", value)}
        placeHolder={"Select Company"}
      />

      <InputGroup
        label="Date Range"
        inputs={[
          <>
            <input type="date"/>
            <span className="icon">
              <CalenderIcon className="vaMiddle" width={20} height={20} />
            </span>
          </>,
          <>
            <input type="date" />
            <span className="icon">
              <CalenderIcon className="vaMiddle" width={20} height={20} />
            </span>
          </>,
        ]}
      />

      <InputGroup
        label="Pull Range"
        inputs={[
          <>
            <input type="date" />
            <span className="icon">
              <CalenderIcon className="vaMiddle" width={20} height={20} />
            </span>
          </>,
          <>
            <input type="date" />
            <span className="icon">
              <CalenderIcon className="vaMiddle" width={20} height={20} />
            </span>
          </>,
        ]}
      />

      <Dropdown
        label="Status"
        options={["Pending", "In Progress", "Success", "Failed"]}
        onSelect={(value) => console.log("Selected:", value)}
        placeHolder={"Select Status"}
      />

      <Dropdown
        label="Initiator"
        options={["Adrienne Vossler", "Swizz Shannon"]}
        onSelect={(value) => console.log("Selected:", value)}
        placeHolder={"Select Initiator"}
      />
    </Modal>
  );
};

export default FilterDataModal;
